"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var slc = require("../socketLib/socketLibClient");
var contract = require("./socketContract");
exports.Types = contract.Types;
var Client;
(function (Client) {
    Client.increment = function (q) {
        return Promise.resolve({
            num: ++q.num
        });
    };
})(Client || (Client = {}));
// Ensure that the namespace follows the contract
var _checkTypes = Client;
// launch client
exports.server = (_a = slc.run({ clientImplementation: Client, serverContract: contract.server, cast: contract.cast }), _a.server), exports.cast = _a.cast, exports.pendingRequestsChanged = _a.pendingRequestsChanged, exports.connectionStatusChanged = _a.connectionStatusChanged;
// Sample usage
exports.cast.hello.on(function (p) { console.log(p); });
var _a;



/*****************
 ** WEBPACK FOOTER
 ** ./src/socket/socketClient.js
 ** module id = 5
 ** module chunks = 0
 **/